import { Transition } from '@headlessui/react';
import { Fragment, ReactNode } from 'react';

import { cn } from '../../lib/utils';

interface CollapseProps {
  children: ReactNode;
  isOpen?: boolean;
  className?: string;
  navbar?: boolean;
  [key: string]: any;
}

export function Collapse({ children, isOpen = false, className = '', navbar = false, ...props }: CollapseProps) {
  const open = isOpen;

  return (
    <Transition
      show={open}
      as={Fragment}
      enter="transition-all duration-300 ease-in-out"
      enterFrom="max-h-0 opacity-0"
      enterTo="max-h-screen opacity-100"
      leave="transition-all duration-300 ease-in-out"
      leaveFrom="max-h-screen opacity-100"
      leaveTo="max-h-0 opacity-0"
    >
      <div
        data-state={open ? 'open' : 'closed'}
        className={cn('overflow-hidden', navbar ? 'w-full' : '', className)}
        {...props}
      >
        {children}
      </div>
    </Transition>
  );
}
